import { Updater } from 'widgets-for-react'
import {
  initialPaginationState,
  PaginationState,
} from '../../pagination/paginationState'
import {
  DishTeasersState,
  initialDishTeasersState,
} from '../dishTeasers/dishTeasersState'
import { getDishCount, getDishTeasers } from './dishOverviewApi'

export type DishOverviewState = {
  dishTeasersState: DishTeasersState
  paginationState: PaginationState
}

export const initialDishOverviewState = (page: number): DishOverviewState => ({
  dishTeasersState: initialDishTeasersState(() => getDishTeasers(page)),
  paginationState: initialPaginationState(getDishCount),
})

export const dishOverviewStateUpdaters = {
  updateDishTeasersState:
    (update: Updater<DishTeasersState>) =>
    (currentState: DishOverviewState): DishOverviewState => ({
      ...currentState,
      dishTeasersState: update(currentState.dishTeasersState),
    }),
  updatePaginationState:
    (update: Updater<PaginationState>) =>
    (currentState: DishOverviewState): DishOverviewState => ({
      ...currentState,
      paginationState: update(currentState.paginationState),
    }),
}
